import type { ToDoTaskRow } from "@/openapi/generated";
import { UserTaskStatus } from "@/openapi/generated";

function statusRank(status: ToDoTaskRow["status"]): number {
  if (status === UserTaskStatus.InProgress) return 0;
  if (status === UserTaskStatus.Open) return 1;
  return 2;
}

function dueSortKey(dueAt: Date | null): number {
  return dueAt?.getTime() ?? Number.MAX_SAFE_INTEGER;
}

/** In progress first, then open; within group by due (none last), then newest created. */
export function sortTodoWidgetTasks(tasks: ToDoTaskRow[]): ToDoTaskRow[] {
  return [...tasks].sort((a, b) => {
    const byStatus = statusRank(a.status) - statusRank(b.status);
    if (byStatus !== 0) return byStatus;

    const byDue = dueSortKey(a.dueAt) - dueSortKey(b.dueAt);
    if (byDue !== 0) return byDue;

    return b.createdAt.getTime() - a.createdAt.getTime();
  });
}
